<template>
    <div class="col-12">
      <div class="search-padd">
      <form v-on:submit.prevent>
        <div class="col-xs-12 override-padding">
          <div class="crm_admin_heading mentee_heading_1 text-align-left">First Name</div>
          <div class="crm_admin_heading mentee_heading_1 text-align-left">Last Name</div>
          <div class="crm_admin_heading mentee_heading_2 text-align-left">Email</div>
          <div class="crm_admin_heading mentee_heading_2 text-align-left">Mobile</div>
          <div class="crm_admin_heading mentee_heading_3 text-align-center">Active</div>
        </div>
        <div style="clear: both;"></div>
        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
          <div class="admin_details" id="mentee_details_more">
            <div class="crm_admin_field_lists mentee_heading_1 text-align-left">
              <div class="search-padd">
              <input
                  type="hidden"
                  name="uid"
                  id="uid"
                  v-model="account_mentee.uid">
                <input
                    type="text"
                    id="mentee_fname"
                    class="col-12 col-sm-12 ma-input-field"
                    ref="mentee_fname"
                    name="mentee_fname"
                    v-model="account_mentee.mentee_fname"
                    v-validate="{ rules: { required: true, regex: nameRegex() } }"
                    placeholder="First Name"
                    maxlength="250"
                    @keydown.enter.prevent='enterSearchAction()'>
                  <div v-if="verrors.firstByRule('mentee_fname', 'required')" class="margin-bottom-5 validate-warning-msg">First name is required</div>
                  <div v-if="verrors.firstByRule('mentee_fname', 'regex')" class="margin-bottom-5 validate-warning-msg">First name should only contain - and _</div>
              </div>
            </div>
            <div class="crm_admin_field_lists mentee_heading_1 text-align-left">
              <div class="search-padd">
                <input
                    type="text"
                    id="mentee_lname"
                    class="col-12 col-sm-12 ma-input-field"
                    ref="mentee_lname"
                    name="mentee_lname"
                    v-model="account_mentee.mentee_lname"
                    v-validate="{ rules: { required: true, regex: nameRegex() } }"
                    placeholder="Last Name"
                    maxlength="250"
                    @keydown.enter.prevent='enterSearchAction()'>
                  <div v-if="verrors.firstByRule('mentee_lname', 'required')" class="margin-bottom-5 validate-warning-msg">Last name is required</div>
                  <div v-if="verrors.firstByRule('mentee_lname', 'regex')" class="margin-bottom-5 validate-warning-msg">Last name should only contain - and _</div>
              </div>
            </div>
            <div class="crm_admin_field_lists mentee_heading_2 text-align-left">
              <div class="search-padd">
                <input
                    type="text"
                    id="mentee_email"
                    class="col-12 col-sm-12 ma-input-field"
                    ref="mentee_email"
                    name="mentee_email"
                    v-model="account_mentee.mentee_email"
                    v-validate="'required|email'"
                    placeholder="Email"
                    maxlength="250"
                    @keydown.enter.prevent='enterSearchAction()'>
                <div v-if="verrors.firstByRule('mentee_email', 'required')" class="margin-bottom-5 validate-warning-msg">Email is required</div>
                <div v-if="verrors.firstByRule('mentee_email', 'email')" class="margin-bottom-5 validate-warning-msg">Email is invalid</div>
                <div v-if="verrors.firstByRule('mentee_email', 'exists')" class="margin-bottom-5 validate-warning-msg">Email address already exists</div>
              </div>
            </div>
            <div class="crm_admin_field_lists mentee_heading_2 text-align-left">
              <div class="search-padd">
                <input
                    type="text"
                    id="mentee_phone"
                    class="col-12 col-sm-12 ma-input-field"
                    ref="mentee_phone"
                    name="mentee_phone"
                    v-model="account_mentee.mentee_phone"
                    v-validate="{ rules: { regex: phoneRegex(), required: true } }"
                    @keyup="phoneValid"
                    @blur="phoneValid"
                    placeholder="Mobile Number"
                    maxlength="14">
                <div v-if="verrors.firstByRule('mentee_phone', 'required')" class="margin-bottom-5 validate-warning-msg">Mobile number is required</div>
                <div v-if="verrors.firstByRule('mentee_phone', 'regex')" class="margin-bottom-5 validate-warning-msg">Mobile number is invalid</div>
              </div>
            </div>
            <div class="crm_admin_field_lists mentee_heading_3 text-align-center" style="padding-top: 16px;">
              <div class="search-padd">
                <input
                    type="checkbox"
                    id="is_enabled"
                    name="is_enabled"
                    ref="is_enabled"
                    v-model="account_mentee.mentee_is_active"
                    :value="1">
              </div>
            </div>
          </div>
          <div style="clear: both;"></div>
        </form>
      </div>
    </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import EventBus from '../../bus';
import Multiselect from 'vue-multiselect';
Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
      props: ['accountId'],
      data() {
        return {
          account_mentee: [],
          taskLists: [],
          mentors: [],
          loading: false,
          tasklists_assigned: [],
          mentor_assigned: [],
          isDeleteModalVisible: false,
          parent_id: '',
          delete_id: '',
          mentor_label_name: 'Mentor(s)',
          updated_account_mentees: {},
          account_type: ''
        }
      },
      components: {
         Multiselect,
      },
      methods: {
        nameRegex: function() {
          return /^[\w- ']*$/;
        },        
        phoneValid: function(event) {
            var phone = this.account_mentee.mentee_phone;
            this.account_mentee.mentee_phone = phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        },
        phoneRegex: function() {
            return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        },
        enterSearchAction: function() {
            this.$parent.searchAction();
        }
      },
      created: function () {
        this.account_type = this.$parent.org_type;
        this.loading = false;
      },
    }
</script>


<style>
#mentee-tasklist-wrapper li span.multiselect__option--selected span::before,
#mentee-group-wrapper li span.multiselect__option--selected span::before {
  content: '\2713';
  color: #fff;
  background-color: #007bff;
  padding: 3px;
  margin-right: 5px;
}
#mentee-tasklist-wrapper li span.multiselect__option--selected.multiselect__option--highlight,
#mentee-group-wrapper li span.multiselect__option--selected.multiselect__option--highlight {
  background-color: #fff !important;
  color: #212529 !important;
  font-weight: normal !important;
}
.multiselect__option--highlight {
  font-weight: normal !important;
  background-color: #fff !important;
  color: #212529 !important;
}
.multiselect__content-wrapper {
  min-width: 100%;
  width: auto !important;
  border-top: 1px solid #000 !important;
  border: 1px solid #000 !important;
}
.multiselect__option {
  font-size:13px;
}
.multiselect__option--selected {
  font-size: 13px;
  font-weight: normal !important;
}
.mentee_heading_1 {
  width: 20%;
}
.mentee_heading_2 {
  width: 20%;
}
.mentee_heading_3 {
  width: 20%;
}
.ma-input-field {
  line-height: 30px;
  margin-bottom: 5px;
  padding: 0 5px;
  border: 0 none;
  color: #707070;
  min-height: 38px;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/admin/account_lookup_mentee_search_tab.vue